import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import DashboardSidebar from "../../../components/DashboardSidebar/DashboardSidebar";
import ScrollToTopButton from "../../../components/scrollToTopButton/scrollToTopButton";
import { getPlansAPI } from "../../../redux/features/authSlice";
import { useEffect } from "react";

export default function DashboardLayout() {
  const auth = useSelector((state) => state.auth);
  const paymentPlanStatus = auth.planPaymentStatus;
  const token = auth.token;
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await dispatch(getPlansAPI(token)).unwrap();
      } catch (error) {}
    };
    fetchPlans();
  }, [dispatch, token]);

  if (auth.role?.toLowerCase() === "student") {
    const hasActivePlan =
      auth.plans?.some((plan) => plan.status === "active") ?? false;

    if (!paymentPlanStatus && !hasActivePlan) {
      return <Navigate to="/choose-plan" replace />;
    }
  }

  // Render the layout if checks pass
  return (
    <div className="student-dashboard">
      <DashboardSidebar />
      <div className="content-wrapper">
        <ScrollToTopButton />
        <Outlet />
      </div>
    </div>
  );
}